import { FileUpload } from './file';

export class Critter {
  id: number;
  name: string;
  description: string;
  position: number;
  avatarImageId: string;
  profileImageId: string;
  avatarImage: FileUpload;
  profileImage: FileUpload;
}

export class UpdateStudentAvatarDTO {
  ignoreFee: boolean = false;
}
